// =============================================================================
// Card.tsx — Playing card component (CSS-rendered, no images)
// Project: Texas Hold'em Social Casino
// =============================================================================
// Renders a playing card entirely with CSS. Supports face-up and face-down
// states. The cardback design follows a standard poker aesthetic.

import React from 'react'
import { Card as CardType } from '../types'

const SUIT_SYMBOLS: Record<string, string> = {
  hearts: '♥',
  diamonds: '♦',
  clubs: '♣',
  spades: '♠',
}

const RANK_LABELS: Record<number, string> = {
  2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8',
  9: '9', 10: '10', 11: 'J', 12: 'Q', 13: 'K', 14: 'A',
}

interface CardProps {
  card?: CardType | null
  faceDown?: boolean
  size?: 'small' | 'medium' | 'large'
  animated?: boolean
}

export default function CardComponent({ card, faceDown = false, size = 'medium', animated = false }: CardProps): React.ReactElement {
  const sizeClass = size === 'small' ? 'card-small' : size === 'large' ? 'card-large' : ''

  if (faceDown || !card) {
    return (
      <div className={`card card-face-down ${sizeClass} ${animated ? 'card-deal' : ''}`} />
    )
  }

  const isRed = card.suit === 'hearts' || card.suit === 'diamonds'
  const rankLabel = RANK_LABELS[card.rank] || '?'
  const suitSymbol = SUIT_SYMBOLS[card.suit] || '?'

  return (
    <div className={`card ${sizeClass} ${isRed ? 'card-red' : 'card-black'} ${animated ? 'card-deal' : ''}`}>
      <div style={{ position: 'absolute', top: 4, left: 4, fontSize: '0.6em', lineHeight: 1 }}>
        <div>{rankLabel}</div>
        <div>{suitSymbol}</div>
      </div>
      <div style={{ fontSize: isRed ? '1.4em' : '1.6em' }}>
        {suitSymbol}
      </div>
      <div style={{ position: 'absolute', bottom: 4, right: 4, fontSize: '0.6em', lineHeight: 1, transform: 'rotate(180deg)' }}>
        <div>{rankLabel}</div>
        <div>{suitSymbol}</div>
      </div>
    </div>
  )
}
